<template>
	<section class="feature_image_content">
		<slot v-if="showBreadcrumbs === 'yes'"></slot>
		<div
			class="container"
			:class="{
        'popout-right': popoutDirection === 'right',
        'popout-left': popoutDirection === 'left',
      }"
			:style="{ '--image-max-height': imageMaxHeight + 'px' }"
		>
			<div
				class="inner"
				:class="{ 'not-half': !featureImage }"
			>
				<div class="half content">
					<h1
						v-if="featureTitle"
						v-html="featureTitle"
					></h1>

					<div
						class="copy"
						v-if="featureCopy"
						v-html="featureCopy"
					></div>

					<site-button
						v-for="(button, index) in JSON.parse(buttons)"
						:key="index"
						:link="button.button_link"
						:label="
              button.button_label
                ? button.button_label
                : button.button_link.title
            "
						:colour="button.button_colour"
					></site-button>
				</div>

				<div
					class="half image"
					v-if="contentChoice === 'image' && featureImage"
					:class="{'no-image': !featureImage}"
				>
					<img
						v-if="featureImage"
						v-lazy="JSON.parse(featureImage).url"
						class="lazy"
						:alt="
              JSON.parse(featureImage).alt
                ? JSON.parse(featureImage).alt
                : featureTitle
            "
					/>
				</div>
				<div
					class="copy two"
					v-else
				><span v-html="featureCopy2"></span></div>
			</div>
		</div>
	</section>
</template>

<script>
import SiteButton from './SiteButton.vue';
import SampleImage from '../../images/sample.jpg';

export default {
  data() {
    return {
      sampleImage: SampleImage,
    };
  },

  props: {
    featureTitle: {},
    featureCopy: {},
    featureCopy2: {},
    featureImage: {},
    popoutDirection: {
      default: 'right',
    },
    imageMaxHeight: {
      default: '600',
    },
    buttons: {},
    showBreadcrumbs: {
      default: 'no',
    },
    contentChoice: {},
  },

  computed: {},

  watch: {},

  methods: {},

  components: {
    SiteButton,
  },

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.feature_image_content {
  background: $cpmec-blue;
  width: 100%;

  @media (max-width: $lg) {
    min-height: auto;
    margin: 0 0 0;
    width: 100%;
  }

  > .container {
    @media (max-width: $lg) {
      padding: 0;
    }

    &.popout-right {
      .inner {
        grid-template-columns: 1fr 1fr;
        width: 100%;

        // @media (max-width: $max-width) {
        //   width: calc(100% - (20px * 3));
        // }

        @media (max-width: $lg) {
          grid-template-columns: 1fr;
          width: 100%;
        }

        .content {
          order: 0;
          padding-right: 50px;

          @media (max-width: $lg) {
            order: 1;
            padding: $spacer $spacer 0;
          }
        }

        .image {
          order: 1;

          @media (max-width: $lg) {
            order: 0;
            height: 240px;
            margin-top: -20px;
            overflow: hidden;
            padding: 0;
          }
        }
      }
    }

    &.popout-left {
      .inner {
        grid-template-columns: 1fr 1fr;
        width: 100%;

        @media (max-width: 1740px) {
          width: calc(100% - (20px * 3));
        }

        @media (max-width: $lg) {
          grid-template-columns: 1fr;
          width: 100%;
        }

        .content {
          order: 1;
          padding-left: 50px;

          @media (max-width: $lg) {
            order: 1;
            padding: $spacer $spacer 0;
          }
        }

        .image {
          order: 0;

          @media (max-width: $lg) {
            order: 0;
            height: 240px;
            margin-top: -20px;
            overflow: hidden;
            padding: 0;
          }
        }
      }
    }
  }

  #breadcrumbs {
    background-color: $cpmec-grey;
    position: relative;
    z-index: 10;

    a,
    span {
      color: white;
    }

    .colour-wrapper {
      background: rgba($cpmec-blue, 0.1);
      .container {
        padding: $spacer $spacer * 2;

        @media (max-width: $lg) {
          padding: $spacer;
        }

        span {
          &.divider {
            margin: 0 $spacer;
          }
        }
      }
    }
  }

  .inner {
    display: grid;
    overflow-x: hidden;

    @media (max-width: $lg) {
      padding: 0 0;
      overflow-x: visible;
    }

    .copy {
      margin: 0 0 $spacer * 2;

      @media (max-width: $lg) {
        margin: 0 0 0;
        padding: 0 0;
      }

      @media (max-width: $md) {
          padding: $spacer;
        }

      a {
        color: white;
        margin: 0 0 $spacer * 2;
        font-size: 25px;
        text-decoration: none;

        @media (max-width: $lg) {
          font-size: 18px;
          margin: 0 0 $spacer;
        }
      }

      p {
        color: white;
        margin: 0 0 $spacer * 2;
        font-size: 25px;

        &:first-child {
          color: white;
        }

        @media (max-width: $lg) {
          font-size: 18px;
          margin: 0 0 $spacer;
        }

        @media (max-width: $md) {
          padding: $spacer;
          line-height: 25px;
        }
      }

      &.two {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: auto;
        margin: 0;

        @media (max-width: $lg) {
          min-height: auto;
          order: 1;
        }
      }
    }

    .half {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      .site_button {
        margin-bottom: $spacer;
      }

      &.content {
        padding-top: $spacer * 3;

        @media (max-width: $lg) {
          padding: 0 0 0;
        }

        h1 {
          color: white;
          margin: 0 0 $spacer * 2;
          font-size: 60px;
          line-height: 70px;
          font-family: $font-family;
          font-weight: normal;

          @media (max-width: $lg) {
            font-size: 50px;
            line-height: 74px;
            margin: 0 0 $spacer;
            padding: 0 0;
          }

          @media (max-width: $md) {
            font-size: 45px;
            line-height: 60px;
            margin: 0 0 0;
          }

          @media (max-width: $xs) {
            font-size: 40px;
            line-height: 45px;
            margin: 0 0 0;
          }
        }

        .copy {
          margin: 0 0 $spacer * 2;

          @media (max-width: $lg) {
            margin: 0 0 0;
          }

          a {
            color: white;
            margin: 0 0 $spacer * 2;
            font-size: 25px;
            text-decoration: none;

            @media (max-width: $lg) {
              font-size: 18px;
              margin: 0 0 $spacer;
            }
          }

          p {
            color: white;
            margin: 0 0 $spacer * 2;
            font-size: 25px;

            &:first-child {
              color: white;
            }

            @media (max-width: $lg) {
              font-size: 18px;
              margin: 0 0 $spacer;
            }
          }

          & .two {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }
      }

      img {
        width: 100%;
        height: var(--image-max-height);
        object-fit: cover;
        max-height: var(--image-max-height);
        max-width: 100%;

        // @media (max-width: $lg) {
        // 	margin-top: -20px;
        // 	position: absolute;
        // 	z-index: 100;
        // 	width: calc(100% - 40px);
        // }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/FeatureImageContentSection.vue